module.exports = __webpack_public_path__ + "img/OY0002.ab4da4e.jpg";